import React from "react";
import { Outlet } from "react-router-dom";

const Users = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Users;
